import React, { FC, ReactNode, useContext } from 'react';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Tooltip from 'rc-tooltip';

import { NavigationContext } from '@buyside/components/presentation/MainSiteLayout/mainSiteLayout';

import styles from './sideNavigationDropdownStyles.scss';

const SideNavigationItem: FC<{
  active: boolean;
  analyticsTag?: string;
  collapsedIcon?: ReactNode;
  disabled?: boolean;
  hasNewLabel?: boolean;
  name: string;
  url: string;
}> = ({ active, analyticsTag, collapsedIcon, disabled, hasNewLabel, name, url }) => {
  const { sideNavigationOpen } = useContext(NavigationContext) || {};

  const itemName = (
    <div>
      {name}
      {hasNewLabel && <span className={styles.newLabel}>NEW</span>}
    </div>
  );

  return (
    <div
      className={classNames(styles.navigationItem, {
        [styles.active]: active,
        [styles.sideNavigationOpen]: sideNavigationOpen
      })}
    >
      {disabled ? (
        <span className={classNames(styles.navigationItemName, styles.disabled)}>
          {sideNavigationOpen ? itemName : null}
          <FontAwesomeIcon icon={faLock} />
        </span>
      ) : sideNavigationOpen ? (
        <a className={styles.navigationItemName} data-heap={analyticsTag} href={url}>
          {itemName}
        </a>
      ) : (
        <Tooltip
          placement="right"
          overlay={
            <div className={styles.navigationDropdownTooltip}>
              <span className={styles.navigationDropdownTooltipName}>
                <strong>{name}</strong>
              </span>
            </div>
          }
        >
          <a className={styles.navigationItemName} data-heap={analyticsTag} href={url}>
            {collapsedIcon}
          </a>
        </Tooltip>
      )}
    </div>
  );
};

export default SideNavigationItem;
